"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRoutes = exports.createRoute = void 0;
var react_1 = __importStar(require("react"));
var useRouteFallback_1 = __importDefault(require("./useRouteFallback"));
var LazyRoute = function (_a) {
    var Component = _a.component;
    var Fallback = (0, useRouteFallback_1.default)();
    return (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Fallback, null) },
        react_1.default.createElement(Component, null)));
};
var createRoute = function (_a, parentRoute) {
    var component = _a.component, path = _a.path, rest = __rest(_a, ["component", "path"]);
    var LazyComponent = (0, react_1.lazy)(component);
    var LazyElement = react_1.default.createElement(LazyRoute, { component: LazyComponent });
    return __assign(__assign({}, rest), { element: LazyElement, path: path, fullPath: "".concat(parentRoute.fullPath, "/").concat(path), preload: component });
};
exports.createRoute = createRoute;
var createRoutes = function (inRoutes, parentRoute) {
    var outRoutes = {};
    Object.entries(inRoutes).forEach(function (_a) {
        var routeName = _a[0], routeDefinition = _a[1];
        outRoutes[routeName] = (0, exports.createRoute)(routeDefinition, parentRoute);
    });
    return outRoutes;
};
exports.createRoutes = createRoutes;
